// src/lib/kinema/core/tools/ToolManager.ts
import type { Tool } from './types';

export class ToolManager {
  private tools = new Map<string, Tool>();
  private activeTool: Tool | null = null;

  register(tool: Tool): void {
    this.tools.set(tool.name, tool);
    if (!this.activeTool) {
      this.activeTool = tool;
    }
  }

  setActiveTool(name: string): void {
    const tool = this.tools.get(name);
    if (!tool) throw new Error(`Unknown tool: ${name}`);
    if (tool === this.activeTool) return;

    this.activeTool?.deactivate?.();
    this.activeTool = tool;
    tool.activate?.();
  }

  getActiveTool(): Tool {
    if (!this.activeTool) throw new Error('No tools registered');
    return this.activeTool;
  }
}
